module.exports = __webpack_public_path__ + "static/img/recharge.f708f80.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/new-user/recharge.gif
// module id = 3XCT
// module chunks = 4